import table from '@/../public/i18n/products.json'
import { pickUiMessagesForSite, stripI18nUsage } from '@/components/shared/utils/uiMessages'

export function getProductMessages(localeCode) {
  return pickUiMessagesForSite(stripI18nUsage(table), localeCode)
}
